import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { epicsErrorHandler } from '../../epics'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../PartnerOptions/constants'

import { fetchResourcesError, fetchResourcesSuccess } from './actions'
import { FETCH_RESOURCES_ASYNC } from './constants'

const fetchResourcesEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(FETCH_RESOURCES_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.resources.self)
      return true
    }),
    mergeMap(() =>
      api.accounts.getResources(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => fetchResourcesSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchResourcesError, error))),
        takeUntil(action$.pipe(ofType(FETCH_RESOURCES_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpicsIsolated(fetchResourcesEpic)
